import { getTzaEnvContext } from "./env-definition.mjs";
const TZA_ENV = import.meta.env.VITE_TZA_ENV || "";
const APP_ENV = {
  TZA_ENV,
  TZA_ENV_CONTEXT: getTzaEnvContext(TZA_ENV),
  TZA_BACKEND_API_URI_PUBLIC: import.meta.env.VITE_TZA_BACKEND_API_URI_PUBLIC || "",
  TZA_BACKEND_API_URI: import.meta.env.VITE_TZA_BACKEND_API_URI || "",
  TZA_FRONTEND_URI_PUBLIC: import.meta.env.VITE_TZA_FRONTEND_URI_PUBLIC || "",
  CLERK_PUBLISHABLE_KEY: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || "",
  STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || "",
  FCM_VAPID: import.meta.env.VITE_FCM_VAPID || ""
};
export { APP_ENV };
//# sourceMappingURL=env.mjs.map
